///<reference path="../../../../../typings/index.d.ts"/>
///<reference path="../short-cuts.interfaces.ts"/>
///<reference path="../short-cuts.helper.ts"/>
///<reference path="../short-cuts.module.ts"/>

module Meevo.Components.ShortCuts {
    'use strict';

    interface IShortCutDirectiveAttrs {
        meevoShortCutClick: keyof ICombinationNames | string;
        meevoShortCutClickLabel?: 'true' | 'false';
        meevoShortCutClickClass?: string;
    }

    class MeevoShortCutClickDirective implements angular.IDirective {

        static factory(): angular.IDirectiveFactory {
            const directive = ($timeout: ng.ITimeoutService, shortCutsService: IShortCutsService, shortCutsHelper: IShortCutHelper) => {
                return new MeevoShortCutClickDirective($timeout, shortCutsService, shortCutsHelper);
            };

            directive.$inject = [
                '$timeout',
                'meevo.components.short-cuts.ShortCutsService',
                'meevo.components.short-cuts.ShortCutsHelper',
            ];

            return directive;
        }

        restrict = 'A';
        priority = -1;

        constructor(private $timeout: ng.ITimeoutService,
                    private shortCutsService: IShortCutsService,
                    private shortCutsHelper: IShortCutHelper) {
        }

        link(scope: angular.IScope, element: angular.IAugmentedJQuery, attrs: IShortCutDirectiveAttrs) {
            const addLabel: boolean = attrs.meevoShortCutClickLabel !== 'false'; // default True

            if (addLabel) {
                this.shortCutsHelper.addLabel(element, {
                    shortCutKey: attrs.meevoShortCutClick,
                    additionalClass: attrs.meevoShortCutClickClass
                });
            }

            this.shortCutsService.add(attrs.meevoShortCutClick, (event: Event, hotkey: ng.hotkeys.Hotkey) => {
                event.preventDefault();

                this.$timeout(() => {
                    element.click();
                });
            }, {scope: scope});
        }
    }

    angular.module('meevo.components.short-cuts')
        .directive('meevoShortCutClick', MeevoShortCutClickDirective.factory());
}
